<template>
  <form method="post" @submit.prevent="onSend" novalidate>
    <div class="modal-card" style="width: 600px;">
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">
          {{ formTitle }}
        </p>
        <b-button v-if="!isNew" type="is-danger" @click="onDelete">
          取消
        </b-button>
      </header>
      <section class="modal-card-body">
        <form-wrapper :validator="$v.form">
          <form-group
            horizontal
            name="employee_code"
            attribute="attributes.employee_code"
            :label="$t('attributes.employee_code')"
            label-position="on-border"
          >
            <b-autocomplete
              ref="salesSelect"
              v-model="employeeSearch"
              name="employee_code"
              field="name"
              keep-first
              select-on-click-outside
              placeholder="搜尋員工編號/姓名"
              :custom-formatter="e => e.emp_code"
              :data="employees"
              :loading="isLoadingEmployees"
              :open-on-focus="true"
              @typing="loadEmployees"
              @select="onSelectEmployee"
              :disabled="!isNew || !isOwner"
            >
              <template #default="props">
                <p>
                  [{{ props.option.emp_code }}]
                  <span v-html="props.option.name"></span>
                </p>
              </template>
            </b-autocomplete>
          </form-group>
          <form-group
            horizontal
            name="name"
            attribute="attributes.fullname"
            :label="$t('attributes.fullname')"
          >
            <b-input
              v-model="form.name"
              name="name"
              maxlength="20"
              :has-counter="false"
              :placeholder="
                $t('message.please_input_', [$t('attributes.fullname')]) +
                  $t('message.word_limit', [20])
              "
              disabled
            ></b-input>
          </form-group>
          <form-group
            horizontal
            name="tel"
            attribute="attributes.meeting_tel"
            :label="$t('attributes.meeting_tel')"
          >
            <b-input
              v-model="form.tel"
              name="tel"
              attribute="attributes.meeting_tel"
              :label="$t('attributes.meeting_tel')"
              maxlength="20"
              :has-counter="false"
              :placeholder="
                $t('message.please_input_', [$t('attributes.meeting_tel')]) +
                  $t('message.word_limit', [20])
              "
            ></b-input>
          </form-group>
          <form-group
            horizontal
            name="remark"
            attribute="attributes.remark"
            :label="$t('attributes.remark')"
          >
            <b-input
              v-model="form.remark"
              name="remark"
              type="textarea"
              rows="4"
              maxlength="500"
              :placeholder="
                $t('message.please_input_', [$t('attributes.remark')])
              "
            ></b-input>
          </form-group>
        </form-wrapper>
      </section>
      <footer class="modal-card-foot">
        <b-button class="is-fullwidth" @click="$parent.close()">
          {{ $t('attributes.close') }}
        </b-button>
        <b-button
          :loading="sending"
          type="is-primary"
          class="is-fullwidth"
          native-type="submit"
        >
          {{
            isOwner
              ? $t('attributes.add')
              : isNew
              ? $t('attributes.meeting_apply')
              : $t('attributes.modify')
          }}
        </b-button>
      </footer>
    </div>

    <b-loading
      :active.sync="sending"
      :is-full-page="false"
      :can-cancel="false"
    ></b-loading>
  </form>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'
import { EMPLOYEES_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import debounce from 'lodash/debounce'

export default {
  name: 'MeetingLessonApplyForm',
  props: {
    isOwner: {
      type: Boolean,
      required: true
    },
    meeting: {
      type: Object,
      required: true
    },
    meetingApply: {
      type: Object,
      required: true
    },
    sending: {
      type: Boolean
    }
  },
  data() {
    const isNew = !this.meetingApply.id

    let formTitle = isNew
      ? this.$t('attributes.meeting_apply')
      : this.$t('attributes.meeting_apply_modify')

    formTitle += ` [${this.meeting.title}] ` + this.$t('attributes.lesson')

    let employeeSearch = null
    if (this.meetingApply.employee_code) {
      employeeSearch = this.meetingApply.employee_code
    }

    return {
      isNew: isNew,
      formTitle: formTitle,

      isLoadingEmployees: false,
      employees: [],
      employeeSearch,

      form: {
        status: isNew ? 'create' : 'update',
        index: this.meetingApply.index,
        id: this.meetingApply.id,
        employee_code: this.meetingApply.employee_code,
        employee_name: this.meetingApply.employee_name,
        name: this.meetingApply.name,
        tel: this.meetingApply.tel,
        remark: this.meetingApply.remark
      }
    }
  },
  validations() {
    return {
      form: {
        employee_code: { required },
        name: { required, maxLength: maxLength(20) },
        tel: { maxLength: maxLength(20) },
        remark: { maxLength: maxLength(200) }
      }
    }
  },
  methods: {
    loadEmployees: debounce(function() {
      if (!this.employeeSearch) {
        this.employees = []
        return
      }

      this.loadEmployeesAsync()
    }, 500),
    async loadEmployeesAsync() {
      const api = `${EMPLOYEES_API}/search`
      const params = {
        search: this.employeeSearch
      }

      this.isLoadingEmployees = true
      try {
        const res = await this.axios.get(api, { params })
        this.employees = res.data.data
      } catch (e) {
        this.employees = []

        notifyService.fetch_error('employee', e)
      } finally {
        this.isLoadingEmployees = false
      }
    },
    onSelectEmployee(option) {
      this.form.employee_code = option && option.emp_code
      this.form.employee_name = option && option.name
      this.form.name = option && option.name
    },

    async onSend() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      if (this.isNew) {
        this.$emit('onCreate', [this.form])
      } else {
        this.$emit('onUpdate', [this.form])
      }
    },
    async onDelete() {
      this.$emit('onDelete', this.meetingApply)
    }
  }
}
</script>
